<script setup lang="ts">
import LegalLayout from "@/modules/legal/components/LegalLayout.vue";
</script>

<template>
  <LegalLayout
    title="Algemene voorwaarden"
    lead="Deze voorwaarden gelden voor alle gebruik van Klupz door een vereniging en regelen wat Bytechnology levert, wat de vereniging zelf doet en waarvoor Bytechnology aansprakelijk is."
    updated="8 oktober 2026"
  >
    <h2>1. Definities</h2>
    <ul>
      <li>
        <b>Bytechnology</b>: Bytechnology, de eenmanszaak van Wilhelmus van
        Dongen, KvK 97949256, Maria van Loontoren 30, 4811 BR Breda,
        info@bytechnology.nl.
      </li>
      <li>
        <b>Vereniging</b>: de rechtspersoon die met Bytechnology een
        overeenkomst sluit.
      </li>
      <li>
        <b>Klupz</b>: het platform voor vrijwilligersbeheer, bestaande uit de
        club-admin-portal, de club-member-portal, de mobiele app en de
        bijbehorende backend.
      </li>
      <li>
        <b>Gebruikers</b>: bestuursleden, beheerders, leden en vrijwilligers die
        namens de Vereniging inloggen.
      </li>
      <li>
        <b>Overeenkomst</b>: de offerte of serviceovereenkomst waarop deze
        voorwaarden van toepassing zijn.
      </li>
    </ul>
    <h2>2. Toepasselijkheid</h2>
    <p>
      Deze voorwaarden zijn van toepassing op alle aanbiedingen en
      overeenkomsten van Bytechnology over Klupz. Afwijkingen gelden alleen als
      ze schriftelijk zijn overeengekomen. Bij strijd gaat de Overeenkomst vóór
      deze voorwaarden. Voorwaarden van de Vereniging zijn uitgesloten.
    </p>
    <h2>3. De dienst</h2>
    <p>
      Bytechnology stelt Klupz beschikbaar, host het en onderhoudt het. Klupz
      biedt onder meer: categorieën, taken en periodes, zelf inschrijven door
      leden, automatische berichten bij aanmelding, wijziging en herinnering, en
      een overzicht van uren, vrijstellingen en afkoop per lid.
    </p>
    <p>
      Bytechnology mag Klupz doorontwikkelen en technisch wijzigen, zolang de
      overeengekomen functionaliteit niet wezenlijk afneemt.
    </p>
    <h2>4. Accounts en toegang</h2>
    <p>
      Inloggen verloopt via een centrale inlogdienst (Keycloak). De Vereniging
      bepaalt wie beheerder of lid is en houdt de gegevens actueel. Gebruikers
      houden hun inloggegevens geheim.
    </p>
    <p>
      De Vereniging is verantwoordelijk voor alles wat onder haar accounts
      gebeurt, tenzij misbruik het gevolg is van een fout van Bytechnology. Een
      vermoeden van misbruik meldt de Vereniging direct.
    </p>
    <h2>5. Gebruik</h2>
    <p>
      De Vereniging en haar Gebruikers gebruiken Klupz alleen voor het
      organiseren van vrijwilligerstaken binnen de Vereniging, volgens de wet en
      deze voorwaarden. Niet toegestaan zijn: beveiligingsmaatregelen omzeilen,
      het systeem onevenredig belasten, gegevens van andere verenigingen
      proberen in te zien, en het laden van onrechtmatige of misleidende inhoud.
    </p>
    <p>
      Bij ernstig misbruik mag Bytechnology toegang tijdelijk blokkeren, zo
      mogelijk na voorafgaande melding.
    </p>
    <h2>6. Gegevens van de Vereniging</h2>
    <p>
      De Vereniging blijft eigenaar van alle gegevens die zij in Klupz invoert
      en is verantwoordelijk voor de juistheid en rechtmatigheid ervan, ook voor
      het hebben van een grondslag om leden in Klupz op te nemen. Bytechnology
      verwerkt persoonsgegevens alleen als verwerker, volgens de
      verwerkersovereenkomst en het privacybeleid.
    </p>
    <h2>7. Onderhoud, support en beschikbaarheid</h2>
    <p>
      Bytechnology streeft naar hoge beschikbaarheid maar garandeert die niet.
      Gepland onderhoud wordt zo mogelijk vooraf gemeld. Storingen meldt de
      Vereniging per e-mail aan info@bytechnology.nl. Reactietijden en omvang
      van het onderhoud staan in de Overeenkomst. Er is geen uptime-SLA, tenzij
      schriftelijk overeengekomen.
    </p>
    <h2>8. Back-ups</h2>
    <p>
      Bytechnology maakt technische back-ups van de database om na een incident
      te kunnen herstellen. Volledig herstel van elke wijziging is niet
      gegarandeerd. De Vereniging kan haar gegevens zelf exporteren,
      bijvoorbeeld ledenlijsten en urenoverzichten.
    </p>
    <h2>9. Vergoeding en betaling</h2>
    <p>
      Tarieven staan in de Overeenkomst. Bytechnology factureert jaarlijks
      vooraf; betaling binnen 14 dagen. Bij te late betaling is de Vereniging de
      wettelijke handelsrente verschuldigd en mag Bytechnology de dienst
      opschorten na een schriftelijke aanmaning van 14 dagen.
    </p>
    <p>
      Tarieven worden jaarlijks geïndexeerd met de CPI (jaar-op-jaar, nooit
      verlagend); wijzigingen worden minimaal één maand vooraf aangekondigd.
      Prijzen zijn vrijgesteld van btw zolang Bytechnology de
      kleineondernemersregeling (KOR) toepast.
    </p>
    <p>
      Nieuwe functionaliteit en extra werk worden apart geoffreerd tegen het dan
      geldende uurtarief en alleen na goedkeuring uitgevoerd.
    </p>
    <h2>10. Intellectueel eigendom</h2>
    <p>
      Alle rechten op Klupz, inclusief broncode, ontwerp en documentatie,
      blijven bij Bytechnology. De Vereniging krijgt een niet-exclusief,
      niet-overdraagbaar gebruiksrecht zolang de Overeenkomst loopt en de
      vergoedingen zijn betaald.
    </p>
    <p>
      Het logo en de huisstijlgegevens die de Vereniging aanlevert, blijven van
      de Vereniging; zij geeft Bytechnology toestemming die in Klupz te tonen.
    </p>
    <h2>11. Externe diensten</h2>
    <p>
      Klupz gebruikt diensten van derden, zoals hosting, e-mail en
      authenticatie. Bytechnology is niet verantwoordelijk voor storingen of
      wijzigingen bij die leveranciers buiten haar invloed. Aanpassingen die
      door zo'n wijziging nodig worden, vallen niet automatisch onder regulier
      onderhoud.
    </p>
    <h2>12. Beveiliging</h2>
    <p>
      Bytechnology treft passende technische en organisatorische maatregelen
      (versleutelde verbindingen, toegangsbeheer, updates, monitoring,
      back-ups). Volledige veiligheid kan niet worden gegarandeerd. Ernstige
      kwetsbaarheden onderzoekt Bytechnology zo snel als redelijkerwijs
      mogelijk.
    </p>
    <h2>13. Aansprakelijkheid</h2>
    <p>
      Bytechnology is alleen aansprakelijk voor directe schade door een
      toerekenbare tekortkoming. Aansprakelijkheid voor indirecte schade,
      gevolgschade, gemiste inkomsten of besparingen en reputatieschade is
      uitgesloten.
    </p>
    <p>
      De totale aansprakelijkheid per kalenderjaar is beperkt tot het bedrag dat
      de Vereniging in de twaalf maanden vóór het schadeveroorzakende feit aan
      Bytechnology heeft betaald. Deze beperkingen vervallen bij opzet of
      bewuste roekeloosheid en voor zover de wet ze niet toestaat.
    </p>
    <p>
      Een schadeclaim moet binnen drie maanden na ontdekking schriftelijk worden
      gemeld.
    </p>
    <h2>14. Overmacht</h2>
    <p>
      Bytechnology hoeft haar verplichtingen niet na te komen bij overmacht,
      zoals storingen bij hostingproviders of internetdiensten, cyberaanvallen,
      stroomuitval, overheidsmaatregelen en andere omstandigheden buiten haar
      redelijke invloed. Duurt overmacht langer dan 60 dagen, dan mag elke
      partij de Overeenkomst schriftelijk beëindigen.
    </p>
    <h2>15. Looptijd en opzegging</h2>
    <p>
      Tenzij de Overeenkomst anders bepaalt, geldt een eerste termijn van 12
      maanden, daarna stilzwijgende verlenging met telkens 12 maanden. Opzeggen
      kan schriftelijk of per e-mail uiterlijk één maand vóór het einde van de
      lopende periode.
    </p>
    <p>
      Bij ernstige tekortkoming mag elke partij ontbinden na schriftelijke
      ingebrekestelling met een redelijke termijn om te herstellen.
    </p>
    <h2>16. Einde van de overeenkomst</h2>
    <p>
      Na het einde blijft de toegang tot het einde van de contractperiode
      bestaan. De Vereniging kan daarin haar gegevens exporteren. Daarna
      verwijdert Bytechnology de gegevens van de Vereniging binnen 30 dagen;
      back-ups worden binnen 90 dagen overschreven. De verplichtingen over
      geheimhouding, aansprakelijkheid en intellectueel eigendom blijven gelden.
    </p>
    <h2>17. Geheimhouding</h2>
    <p>
      Partijen houden vertrouwelijke informatie van de ander geheim en gebruiken
      die alleen voor de uitvoering van de Overeenkomst.
    </p>
    <h2>18. Wijzigingen van de voorwaarden</h2>
    <p>
      Bytechnology mag deze voorwaarden wijzigen. Ze kondigt dat minimaal één
      maand van tevoren aan. Is de Vereniging het er niet mee eens, dan mag zij
      vóór de ingangsdatum opzeggen tegen de datum waarop de nieuwe voorwaarden
      ingaan.
    </p>
    <h2>19. Toepasselijk recht en geschillen</h2>
    <p>
      Nederlands recht is van toepassing. Geschillen gaan naar de bevoegde
      rechter in het arrondissement Zeeland-West-Brabant, nadat partijen eerst
      in overleg hebben geprobeerd het op te lossen.
    </p>
    <h2>20. Slotbepalingen</h2>
    <p>
      Is een bepaling nietig, dan blijven de overige bepalingen gelden en
      vervangen partijen de nietige bepaling door een geldige die het doel zo
      dicht mogelijk benadert. Rechten en plichten uit de Overeenkomst mogen
      niet zonder toestemming van de andere partij worden overgedragen.
    </p>
  </LegalLayout>
</template>
